module.exports = __webpack_public_path__ + "media/images/emblems/Jenins_wappen-871a4585531ebd63a2e11a2fdf64f873.svg";